export enum Granularity {
  H5 = 'h5',
  H10M = 'h10m',
  H1H = 'h1h',
  H1D = 'h1d',
}

export const GranularityIntervalLabels = {
  [Granularity.H5]: '1 day',
  [Granularity.H10M]: '1 day',
  [Granularity.H1H]: '7 days',
  [Granularity.H1D]: '6 months',
};

export const GranularityFrequencyLabels = {
  [Granularity.H5]: '10 min',
  [Granularity.H10M]: '10 min',
  [Granularity.H1H]: '1 hour',
  [Granularity.H1D]: '1 day',
};
